<template>
  <div class="index-module_articleWrap_2Zphx">
      <div class="zhemo">巴菲特价值投资理念：领悟后竟然是人生真谛！</div>
  
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >尽管巴菲特的投资理念在全球各地有着众多追随者，他一直在强调的“价值投资”的精髓究竟是什么呢？作为巴粉，你是否深刻理解了价值投资的意义呢？</span
        >
      </p>
      <!--20--><!--21--><!--22--><!--23--><!--24--><!--25-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >“当我准备买入一只股票的时候，我会综合考虑整个公司的状况来决定是否买入。就像沿着街边逛商场，看遍整个商场的产品之后才会决定要不要买。”——沃伦·巴菲特（Warren
          Buffett）</span
        >
      </p>
      <!--26--><!--27--><!--28--><!--29--><!--30--><!--31-->
    </div>
    <div class="index-module_mediaWrap_213jB">
      <!--32--><!--33-->
      
      <!--34--><!--37--><!--38--><!--39-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >也许在巴菲特说过的这段话中，已然阐述了价值投资的理念：就单只股票而言，从整个公司的发展状况来综合判断价值；就投资市场而言，了解市场中的所有产品来确认更有价值投资空间的产品。</span
        >
      </p>
      <!--40--><!--41--><!--42--><!--43--><!--44--><!--45-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >最近在中国接受媒体采访时，巴菲特还特别谈到了人生与成功，FW融语仔细品读了他的建议，惊喜的发现这些建议同样符合巴菲特价值投资理念！或许价值投资包含着更多的人生真谛？那么请跟着我们的小编一起来解读“揣测”一下吧：</span
        >
      </p>
      <!--46--><!--47--><!--48--><!--49--><!--50--><!--51-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">人生建议</span></p>
      <!--52--><!--53--><!--54--><!--55--><!--56--><!--57-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >巴菲特：“最重要的事是你想和谁联系，和比你更优秀的人交往。模仿某人是你最好的选择，想好你想要模仿谁。虽然你不能选择你的出身，但你能选择你是谁、你崇拜谁、你想成为谁。对于很多人来说，选择配偶、商业伙伴、合作伙伴也是生命中很重要的事。”</span
        >
      </p>
      <!--58--><!--59--><!--60--><!--61--><!--62--><!--63-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">真正的成功</span></p>
      <!--64--><!--65--><!--66--><!--67--><!--68--><!--69-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >巴菲特：“如果你已经65,70岁或者更年长，你爱的人也爱你，那你就是成功的。我认识很多有钱人，但是很少有人会爱他们，孩子们会觉得他们遥不可及。”</span
        >
      </p>
      <!--70--><!--71--><!--72--><!--73--><!--74--><!--75-->
    </div>
    <div class="index-module_mediaWrap_213jB">
      <!--76--><!--77-->
      <div class="index-module_contentImg_JmmC0">
        
      </div>
      <!--78--><!--81--><!--82--><!--83-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">人生真谛1</span></p>
      <!--84--><!--85--><!--86--><!--87--><!--88--><!--89-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p">选股选择最优价值，做人创造与众不同的价值！</span>
      </p>
      <!--90--><!--91--><!--92--><!--93--><!--94--><!--95-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >巴菲特从来就是很不一样，因为在他“投资家”的身份之前，他也在做“商人”。1967年时，巴菲特拥有纺织公司波克夏(Berkshire
          Hathaway)，他运用公司资金来购买一些小型的财险和保险公司。这是巴菲特和多数投资人第一点不一样的地方，巴菲特敢于跨出行业，去了解后投资完全不同类型的产业，如财险和保险。</span
        >
      </p>
      <!--96--><!--97--><!--98--><!--99--><!--100--><!--101-->
    </div>
    <div class="index-module_mediaWrap_213jB">
      <!--102--><!--103-->
      
      <!--104--><!--107--><!--108--><!--109-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >当巴菲特看到这个潜在机会后果断的执行了他的决定，他在1970年代买入了保险公司GEICO半数股权，直到1994年更将整间公司买走。</span
        >
      </p>
      <!--110--><!--111--><!--112--><!--113--><!--114--><!--115-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">人生真谛2</span></p>
      <!--116--><!--117--><!--118--><!--119--><!--120--><!--121-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">一个人的能力有限，选择优秀的人一起合作！</span></p>
      <!--122--><!--123--><!--124--><!--125--><!--126--><!--127-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >说回到巴神的购入的这家公司，在他买入整间公司后，并没有更换管理阶层，并且限制了自己的完全控制权，他会询问管理阶层能力的问题，并且引入更多资金为全公司追求更好的利益。这就是巴菲特和一般投资人不同的第三点，巴菲特会分析投资带来的现金流，并且当公司有好的自由现金流收益前景时，购买部分公司股票或整间公司。</span
        >
      </p>
      <!--128--><!--129--><!--130--><!--131--><!--132--><!--133-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">人生真谛3</span></p>
      <!--134--><!--135--><!--136--><!--137--><!--138--><!--139-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >鸡蛋可以放到不同的篮子中，但永远关注着那几颗最重要的鸡蛋！</span
        >
      </p>
      <!--140--><!--141--><!--142--><!--143--><!--144--><!--145-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >有人评论说巴菲特不会用Beta值去评估市场风险（来源于现代价值投资理论MPT），相反他只投资高品质企业的股票，而他的这个策略是并不能被普通人复制：因为这需要投资者拥有充足的资金才行。其实FW融语小编认为，这一方面是“长期投资”与“短期投资”的差别，另外一方面也是“分散投资”与“重要投资”的差别。也许我们可以将此解读为在进行投资时，鸡蛋并不一定要放到不同的篮子中，但是最重要的那几颗鸡蛋，放到哪个篮子中却需要我们紧密关注！</span
        >
      </p>
      <!--146--><!--147--><!--148--><!--149--><!--150--><!--151-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">人生真谛4</span></p>
      <!--152--><!--153--><!--154--><!--155--><!--156--><!--157-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">不要注重形式，而去追求自己的内心！</span></p>
      <!--158--><!--159--><!--160--><!--161--><!--162--><!--163-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >巴菲特并不怎么在乎投资的形式，他关注着众多投资类型：
          “股票很好，可转换特别股那更好。可转换债券，也不错。信用违约掉期(CDS)只有当我能自己去建构才行，就和卖出期权一样。私募股权还可以，但我会先去寻找关注自己企业文化的私募股权利基。”
          所以，在谈人生时他才会认为，模仿你崇拜的对象，也不失为成为优秀的人的一种途径。总之形式是虚无的，追求自己的内心更为重要。</span
        >
      </p>
      <!--164--><!--165--><!--166--><!--167--><!--168--><!--169-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">人生真谛5</span></p>
      <!--170--><!--171--><!--172--><!--173--><!--174--><!--175-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">耐心地关注机会，伺机而动！</span></p>
      <!--176--><!--177--><!--178--><!--179--><!--180--><!--181-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >在最近的雅虎财经的采访中，巴菲特还说道：“很多人没有意识到需要做的就是投资美国、听从我的建议，或阅读报纸等。他们认为可以交易的时候就该交易，但立刻交易并不明智，对于投资来说并不是一种聪明的方式。”仔细一想，不仅投资如此，人生中的各种重大决策更是这样。匆忙的决策与行动并不能帮到我们，我们需要做的是耐心的守候，知道最好的机会出现，伺机而动！</span
        >
      </p>
      <!--182--><!--183--><!--184--><!--185--><!--186--><!--187-->
    </div>
    <div class="index-module_mediaWrap_213jB">
      <!--188--><!--189-->
      
      <!--190--><!--193--><!--194--><!--195-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">人生真谛6</span></p>
      <!--196--><!--197--><!--198--><!--199--><!--200--><!--201-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p><span class="bjh-p">通过阅读和思考，培养专注力！</span></p>
      <!--202--><!--203--><!--204--><!--205--><!--206--><!--207-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >在FW融语之前的文章《巴菲特投资策略:杀死“繁忙”，专注于少数高质量的工作》中，我们就提到过巴菲特一直遵循着5小时规则，把80%的时间花在阅读和思考上。这也是为什么他认为成功也包含家庭和爱人之间的关爱关系：成功很简单，老了以后你爱的人依然爱着你。所以那些将时间完全耗费于各种“繁忙琐事”的家长，让缺少陪伴的孩子觉得他们遥不可及时，我们不得不重新思考，是否专注少量高质量工作，才是更好的选择。</span
        >
      </p>
      <p class="free">（来源：新浪财经）</p>
      <!--208--><!--209--><!--210--><!--211--><!--212--><!--213-->
    </div>
    <!--13--><!--214--><!--215-->
    
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>